@if (showInfo()) {
  <div class="approval-limit-info" [@approvalLimitInfo]>
    @if (approvedAssetCount() < (gallery().approval_limits | abs)) {
      <div class="progress-container">
        <app-circle-progress-bar
          [progress]="progress()"
          [strokeWidth]="20"
          [size]="40"
          color="green"
        ></app-circle-progress-bar>
      </div>
    } @else {
      @if (approvedAssetCount() === (gallery().approval_limits | abs)) {
        <div class="animated-circle-icon green">
          <app-svg src="/assets/icons/checkmark.svg"></app-svg>
        </div>
      } @else {
        <div class="animated-circle-icon orange">
          <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
        </div>
      }
    }
    <div class="approval-text">{{ approvedAssetCount() }} of {{ gallery().approval_limits | abs }} Approved</div>
  </div>
}
